<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">机侧题库</Breadcrumb-item>
        <Breadcrumb-item>综合题库</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search mex-search">
      <Form :show-message="false" label-position="top">
        <Row :gutter="16">
          <i-col :span="12">
            <Form-item label="题头 ID">
              <Input v-model="queryParam.id" placeholder="题头主键，精确匹配"></Input>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="业务键">
              <Input v-model="queryParam.businessCode" placeholder="如 L1-L-U1-VR-Q001"></Input>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="技能">
              <Select v-model="queryParam.skill" clearable placeholder="请选择技能" @on-change="loadQuestionTypes">
                <Option value="Listening">听力 Listening</Option>
                <Option value="Reading">阅读 Reading</Option>
                <Option value="Writing">写作 Writing</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="级别">
              <Select v-model="queryParam.levelCode" clearable placeholder="请选择级别">
                <Option v-for="lv in levels" :value="lv" :key="lv">{{lv}}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="题型">
              <Select v-model="queryParam.questionType" filterable clearable placeholder="请选择题型">
                <Option v-for="t in questionTypes" :value="t" :key="t">{{questionTypeLabel(t, queryParam.skill)}}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="状态">
              <Select v-model="queryParam.status" clearable placeholder="请选择状态">
                <Option value="PENDING_REVIEW">待审核 PENDING_REVIEW</Option>
                <Option value="ONLINE">已上线 ONLINE</Option>
                <Option value="OFFLINE">已下线 OFFLINE</Option>
                <Option value="DISCARDED">已废弃 DISCARDED</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="场景">
              <Select v-model="queryParam.examScene" clearable placeholder="请选择场景">
                <Option value="GENERAL">通用 GENERAL</Option>
                <Option value="PLACEMENT_ONLY">仅入门测 PLACEMENT_ONLY</Option>
                <Option value="SUMMATIVE_ONLY">仅阶段测 SUMMATIVE_ONLY</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
        <div class="mex-search-actions">
          <Button type="primary" @click="search">搜索</Button>
          <Button type="warning" @click="openBatch">批量编辑</Button>
          <Button type="success" @click="openCreate">新建</Button>
          <Button @click="triggerImport('Listening')">导入听力</Button>
          <Button @click="triggerImport('Reading')">导入阅读</Button>
          <Button @click="triggerImport('Writing')">导入写作</Button>
          <Button @click="downloadTemplate">下载模板</Button>
          <Button @click="triggerIrt">IRT 回填</Button>
          <Button type="info" :loading="inspectLoading" @click="openBankInspect">入门测题库自检</Button>
          <input type="file" ref="fileInput" accept=".xls,.xlsx" style="display:none" @change="importData">
          <input type="file" ref="irtInput" accept=".xls,.xlsx" style="display:none" @change="importIrt">
        </div>
      </Form>
    </div>
    <List ref="list" style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/mex/comp/questions/list"
          :params="queryParam" :onLoading="onLoading" :reload="reload" @on-selection-change="selectionChange"></List>
    <MexQuestionBatchModal v-model="batchVisible" bank="comp" :selected-rows="selection"
                           :skill="queryParam.skill" @success="search"></MexQuestionBatchModal>
    <Modal v-model="inspectVisible" title="入门测题库自检" width="900" :mask-closable="false">
      <p class="mex-dim-hint" v-if="inspectReport">
        规则 {{inspectReport.ruleVersion || '—'}} / 校准 {{inspectReport.calibrationVersion || '—'}}
        · 问题 {{inspectReport.issueCount || 0}} 条
        · {{inspectReport.ok ? '通过' : '未通过'}}
      </p>
      <Table v-if="inspectRows.length" :columns="inspectColumns" :data="inspectRows" size="small"
             max-height="420"></Table>
      <p v-else-if="inspectReport">未发现 BANK 问题</p>
      <p v-else>加载中…</p>
      <div slot="footer">
        <Button @click="inspectVisible = false">关闭</Button>
        <Button type="primary" :loading="inspectLoading" @click="openBankInspect">重新自检</Button>
      </div>
    </Modal>
    <Modal v-model="editVisible" title="编辑题目" width="960">
      <p>业务键 {{businessCode}} / 版本 {{form.versionNo}} / {{statusLabel(form.status)}}<span v-if="form.reviewer"> / 审核 {{form.reviewer}}</span></p>
      <div style="max-height:70vh;overflow-y:auto;padding-right:8px">
      <Form :label-width="130">
        <Form-item v-if="createMode" label="业务键">
          <Input v-model="businessCode" placeholder="如 L1-L-U1-VR-Q001"></Input>
        </Form-item>
        <Form-item v-if="!createMode && versions.length" label="历史版本">
          <Select v-model="selectedVersionId" @on-change="switchVersion">
            <Option v-for="v in versions" :value="v.id" :key="v.id">{{v.versionNo}} / {{statusLabel(v.status)}}</Option>
          </Select>
        </Form-item>
        <Row :gutter="12">
          <i-col :span="8">
            <Form-item label="技能">
              <Select v-model="form.skill" transfer @on-change="onFormSkillChange">
                <Option value="Listening">听力 Listening</Option>
                <Option value="Reading">阅读 Reading</Option>
                <Option value="Writing">写作 Writing</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="级别">
              <Input v-model="form.levelCode" placeholder="如 L1.0"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="题型">
              <Select v-model="form.questionType" filterable transfer placeholder="检索已有题型"
                      @on-change="onEditQuestionTypeChange">
                <Option v-for="t in editTypeOptions" :value="t.value" :key="t.value">{{t.label}}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="场景">
              <Select v-model="form.examScene">
                <Option value="GENERAL">通用 GENERAL</Option>
                <Option value="PLACEMENT_ONLY">仅入门测 PLACEMENT_ONLY</Option>
                <Option value="SUMMATIVE_ONLY">仅阶段测 SUMMATIVE_ONLY</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="锚题">
              <Select v-model="form.isAnchor">
                <Option :value="0">否</Option>
                <Option :value="1">是</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="交互类型">
              <Input v-model="form.interactionType" placeholder="如 tap / speak / drag，可空"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="子技能英文">
              <Select v-model="form.subSkillEn" filterable clearable transfer placeholder="选择题库已有子技能"
                      @on-change="onSubSkillEnChange">
                <Option v-for="t in subSkillEnOptions" :value="t.value" :key="'en-' + t.value">{{t.label}}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="子技能中文">
              <Select v-model="form.subSkillCn" filterable clearable transfer placeholder="选择题库已有子技能"
                      @on-change="onSubSkillCnChange">
                <Option v-for="t in subSkillCnOptions" :value="t.value" :key="'cn-' + t.value">{{t.label}}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="次要技能JSON">
              <Input v-model="form.secondarySkillsJson" placeholder='雷达次要技能，可空。如 ["vocab","grammar"]'></Input>
            </Form-item>
          </i-col>
        </Row>
        <Form-item label="中文指令">
          <Input v-model="form.instructionCn" placeholder="给孩子看的中文指令"></Input>
        </Form-item>
        <Form-item label="英文指令">
          <Input v-model="form.instructionEn" placeholder="给孩子看的英文指令"></Input>
        </Form-item>
        <Form-item label="题干脚本">
          <Input v-model="form.script" type="textarea" :rows="2" placeholder="听力朗读脚本，听力题必填"></Input>
        </Form-item>
        <Form-item label="题干">
          <Input v-model="form.stem" type="textarea" :rows="3" placeholder="题目正文"></Input>
        </Form-item>
        <Row :gutter="12">
          <i-col :span="12">
            <Form-item label="题干音频">
              <Input v-model="form.stemAudio" placeholder="音频地址，可空"></Input>
              <MexAssetPreview :path="form.stemAudio" :skill="form.skill" bank="comp" accept="audio/*"
                               @input="form.stemAudio = $event"></MexAssetPreview>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="题干图">
              <Input v-model="form.stemImage" placeholder="图片地址，可空"></Input>
              <MexAssetPreview :path="form.stemImage" :skill="form.skill" bank="comp" accept="image/*"
                               @input="form.stemImage = $event"></MexAssetPreview>
            </Form-item>
          </i-col>
        </Row>
        <Form-item label="选项">
          <p class="mex-dim-hint">选择题填代号、文字和图片；拖字母/句子排序填可拖的字母或词块；完形、Gap Fill、判断、填空、四格写作选「无选项」。词形选词填空把词库写在选项文字里，不要填图片。</p>
          <Select v-model="optionMode" style="width:220px;margin-bottom:8px">
            <Option value="NONE">无选项</Option>
            <Option value="CHOICE">选择题</Option>
            <Option value="DRAG">拖拽字母/词块</Option>
          </Select>
          <div v-if="optionMode === 'CHOICE'">
            <div v-for="(opt, idx) in choiceOptions" :key="'opt-' + idx" class="mex-dim-card" style="margin-bottom:10px">
              <div class="mex-opt-head">
                <span>选项 {{opt.code || (idx + 1)}}</span>
                <Button size="small" type="text" @click="removeChoice(idx)">删除</Button>
              </div>
              <Form :show-message="false" label-position="top">
                <Row :gutter="12">
                  <i-col :span="6">
                    <Form-item label="代号">
                      <Select v-model="opt.code">
                        <Option v-for="c in optionCodes" :value="c" :key="c">{{c}}</Option>
                      </Select>
                    </Form-item>
                  </i-col>
                  <i-col :span="9">
                    <Form-item label="文字">
                      <Input v-model="opt.text" placeholder="选项文案；纯图题可空"></Input>
                    </Form-item>
                  </i-col>
                  <i-col v-if="!isWordFormType" :span="9">
                    <Form-item label="图片">
                      <Input v-model="opt.image" placeholder="选项图片地址，可空"></Input>
                      <MexAssetPreview :path="opt.image" :skill="form.skill" bank="comp" accept="image/*"
                                       @input="opt.image = $event"></MexAssetPreview>
                    </Form-item>
                  </i-col>
                </Row>
              </Form>
            </div>
            <Button type="dashed" long @click="addChoice">添加选项</Button>
          </div>
          <div v-if="optionMode === 'DRAG'" class="mex-dim-card">
            <Form :show-message="false" label-position="top">
              <Row :gutter="8">
                <i-col :span="6" v-for="(tok, idx) in dragTokens" :key="'tok-' + idx">
                  <Form-item :label="'第 ' + (idx + 1) + ' 块'">
                    <Input v-model="tok.value" placeholder="如 l 或 ball">
                      <Button slot="append" @click="removeDrag(idx)">删</Button>
                    </Input>
                  </Form-item>
                </i-col>
              </Row>
            </Form>
            <Button type="dashed" long @click="addDrag" style="margin-bottom:10px">添加一块</Button>
          </div>
        </Form-item>
        <Form-item label="填空">
          <p class="mex-dim-hint">完形、Gap Fill、听读同篇多问：每一问是选项。听力 Fill in the Blanks：同一段音频多空，每空填短语。写作词形：短文留空，上面选项是词库，下面每空填变化后的词形。</p>
          <div v-for="(blank, idx) in blanks" :key="'blank-' + idx" class="mex-dim-card" style="margin-bottom:10px">
            <div class="mex-opt-head">
              <span>第 {{blank.no || (idx + 1)}} 空</span>
              <Button size="small" type="text" @click="removeBlank(idx)">删除</Button>
            </div>
            <Form :show-message="false" label-position="top">
              <Row :gutter="12">
                <i-col :span="6">
                  <Form-item label="空号">
                    <Input-number v-model="blank.no" :min="1" :max="50" placeholder="空号，如 1" style="width:100%"></Input-number>
                  </Form-item>
                </i-col>
                <i-col :span="9">
                  <Form-item label="提示">
                    <Input v-model="blank.prompt" placeholder="题干里这一空的提示，可空"></Input>
                  </Form-item>
                </i-col>
                <i-col :span="9">
                  <Form-item label="答案">
                    <Input v-model="blank.answer" :placeholder="isFillBlanksType ? '这一空的短语答案，如 Rock climbing and kayaking' : '这一空的标准答案，如 hiking'"></Input>
                  </Form-item>
                </i-col>
              </Row>
              <Form-item v-if="isBlankChoiceType" label="本空选项">
                <div v-for="(opt, oi) in (blank.options || [])" :key="'bopt-' + idx + '-' + oi" style="margin-bottom:6px">
                  <Row :gutter="8">
                    <i-col :span="6">
                      <Input v-model="opt.code" placeholder="代号 A"></Input>
                    </i-col>
                    <i-col :span="18">
                      <Input v-model="opt.text" placeholder="选项文字"></Input>
                    </i-col>
                  </Row>
                </div>
              </Form-item>
              <Form-item v-if="isClozeType || isFillBlanksType || isBlankChoiceType || isWordFormType" label="本空解析">
                <Input v-model="blank.explanation" type="textarea" :rows="2" :placeholder="isFillBlanksType ? '这一空的短语解析，可空' : '这一问为什么选这个答案'"></Input>
              </Form-item>
            </Form>
          </div>
          <Button type="dashed" long @click="addBlank">添加一空</Button>
        </Form-item>
        <Form-item label="标准答案">
          <p class="mex-dim-hint">{{answerHint}}</p>
          <Input v-model="form.answerKey" type="textarea" :rows="2" :placeholder="answerPlaceholder"></Input>
        </Form-item>
        <Form-item label="完整参考作答">
          <Input v-model="form.referenceAnswerFull" type="textarea" :rows="2" placeholder="完整示范答案，可空"></Input>
        </Form-item>
        <Row :gutter="12">
          <i-col :span="8">
            <Form-item label="满分">
              <Input v-model="form.fullScore" placeholder="听1-3，读1-5，写客观1-2、主观5-10"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="星级">
              <Input v-model="form.difficultyLevel" placeholder="1-5 星"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="抽题权重">
              <Input v-model="form.adaptiveWeight" placeholder="现稿多为 0.5"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="听力播放次数">
              <Input v-model="form.audioPlayLimit" placeholder="听力默认 2，其他可空"></Input>
            </Form-item>
          </i-col>
        </Row>
        <Form-item label="评分维度">
          <p class="mex-dim-hint">听读客观题填正确性。看图写句、四格故事、邮件/回信用内容、逻辑、语法、词汇。建议合计 100。</p>
          <div class="mex-dim-card">
            <Form :show-message="false" label-position="top">
              <Row :gutter="12">
                <i-col :span="dimensions.length > 1 ? 6 : 8" v-for="d in dimensions" :key="d.key">
                  <Form-item :label="dimLabel(d.key)">
                    <Input-number v-model="d.weight" :min="0" :max="100" placeholder="百分数，如 100" style="width:100%"></Input-number>
                  </Form-item>
                </i-col>
              </Row>
            </Form>
            <p class="mex-dim-hint">当前合计 {{dimSum}}</p>
          </div>
        </Form-item>
        <Form-item label="评分细则">
          <Input v-model="form.scoringRubric" type="textarea" :rows="2" placeholder="人工/规则评分细则，可空"></Input>
        </Form-item>
        <Form-item label="AI基准">
          <Input v-model="form.aiBenchmark" type="textarea" :rows="2" placeholder="AI 评分基准；客观题可空，写作主观建议填"></Input>
        </Form-item>
        <Form-item label="解析">
          <p v-if="isClozeType || isFillBlanksType || isBlankChoiceType || isWordFormType" class="mex-dim-hint">各空解析写在上面每一空里。这里保存时会按空号拼成备份文案。</p>
          <Input v-model="form.explanation" type="textarea" :rows="2" :placeholder="(isClozeType || isFillBlanksType || isBlankChoiceType || isWordFormType) ? '可由每空解析自动拼接' : '解析文案，可空'"></Input>
        </Form-item>
        <Form-item label="考点">
          <Input v-model="form.examPoint" type="textarea" :rows="2" placeholder="考查点，可空"></Input>
        </Form-item>
        <Form-item label="备注">
          <Input v-model="form.remark" type="textarea" :rows="2" placeholder="内部备注，可空"></Input>
        </Form-item>
        <Form-item label="常见错误">
          <Input v-model="form.commonMistakes" type="textarea" :rows="2" placeholder="常见错误说明，可空"></Input>
        </Form-item>
        <Form-item label="知识点">
          <Input v-model="form.knowledgePointHierarchy" placeholder="知识点路径，可空"></Input>
        </Form-item>
        <Row :gutter="12">
          <i-col :span="8">
            <Form-item label="篇章ID">
              <Input v-model="form.passageId" placeholder="同篇阅读共用，如 P-L3-001"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="填空组ID">
              <Input v-model="form.groupId" placeholder="同组填空共用，可空"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="篇章图">
              <Input v-model="form.passageImage" placeholder="篇章图片地址，可空"></Input>
              <MexAssetPreview :path="form.passageImage" :skill="form.skill" bank="comp" accept="image/*"
                               @input="form.passageImage = $event"></MexAssetPreview>
            </Form-item>
          </i-col>
        </Row>
        <Form-item label="篇章正文">
          <Input v-model="form.passageText" type="textarea" :rows="3" placeholder="阅读篇章正文，可空"></Input>
        </Form-item>
        <Form-item label="字数要求">
          <Input v-model="form.wordCountRequirement" placeholder="如 3-4句话，20-40词；客观拼写可填「无」"></Input>
        </Form-item>
        <Form-item label="写作得分要点">
          <Input v-model="form.scoringPoints" type="textarea" :rows="2" placeholder="写作主观得分要点，可空"></Input>
        </Form-item>
        <Form-item label="写作参考范文">
          <Input v-model="form.scoringReference" type="textarea" :rows="2" placeholder="写作参考范文，可空"></Input>
        </Form-item>
        <Form-item label="配图提示词">
          <Input v-model="form.imageGenerationPrompt" type="textarea" :rows="2" placeholder="配图生成提示词，可空"></Input>
        </Form-item>
        <Form-item label="手写范文图">
          <Input v-model="form.answerSampleImage" placeholder="手写范文图地址，可空"></Input>
          <MexAssetPreview :path="form.answerSampleImage" :skill="form.skill" bank="comp" accept="image/*"
                           @input="form.answerSampleImage = $event"></MexAssetPreview>
        </Form-item>
        <Row :gutter="12">
          <i-col :span="8">
            <Form-item label="能力编码">
              <Input v-model="form.abilityDimensionCode" placeholder="如 LIS-01 / REA-01 / WRI-01"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="能力档">
              <Input v-model="form.scoreMappingLevel" placeholder="内部能力档，可空"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="课程单元">
              <Input v-model="form.courseUnitMapping" placeholder="对应课程单元，可空"></Input>
            </Form-item>
          </i-col>
        </Row>
        <Form-item label="能力描述">
          <Input v-model="form.abilityDescription" type="textarea" :rows="2" placeholder="报告用的能力描述，可空"></Input>
        </Form-item>
        <Row :gutter="12">
          <i-col :span="12">
            <Form-item label="全国均分">
              <Input v-model="form.benchmarkNationalAvg" placeholder="如 72.5，可空"></Input>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="同城优秀均分">
              <Input v-model="form.benchmarkCityExcellentAvg" placeholder="如 85，可空"></Input>
            </Form-item>
          </i-col>
        </Row>
        <Form-item label="提升建议">
          <Input v-model="form.improvementSuggestion" type="textarea" :rows="2" placeholder="报告提升建议，可空"></Input>
        </Form-item>
        <Form-item label="练习推荐">
          <Input v-model="form.recommendedPractice" placeholder="推荐练习，可空"></Input>
        </Form-item>
        <Form-item label="前置知识">
          <Input v-model="form.prerequisiteKnowledge" placeholder="前置知识，可空"></Input>
        </Form-item>
        <Form-item label="掌握周期">
          <Input v-model="form.learningCycle" placeholder="如 1-2周，可空"></Input>
        </Form-item>
        <Row :gutter="12">
          <i-col :span="6">
            <Form-item label="IRT b">
              <Input v-model="form.irtB" placeholder="难度 b，可空"></Input>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="IRT a">
              <Input v-model="form.irtA" placeholder="区分度 a，可空"></Input>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="IRT c">
              <Input v-model="form.irtC" placeholder="猜测 c，可空"></Input>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="失误率">
              <Input v-model="form.childSlip" placeholder="儿童失误率，可空"></Input>
            </Form-item>
          </i-col>
        </Row>
      </Form>
      </div>
      <div slot="footer">
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" @click="saveEdit">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import MexQuestionBatchModal from './MexQuestionBatchModal'
import MexAssetPreview from './MexAssetPreview'
import { questionTypeLabel, skillLabel } from './mex-question-type'

export default {
  name: 'MexCompQuestionList',
  components: { MexQuestionBatchModal, MexAssetPreview },
  data () {
    return {
      searchLoading: false,
      reload: 0,
      importSkill: 'Listening',
      batchVisible: false,
      inspectVisible: false,
      inspectLoading: false,
      inspectReport: null,
      inspectRows: [],
      inspectColumns: [
        { title: '码', key: 'code', width: 100 },
        { title: '库', key: 'bank', width: 80 },
        { title: '题目ID', key: 'id', width: 100 },
        { title: '级别', key: 'level', width: 80 },
        { title: '技能', key: 'skill', width: 100 },
        { title: '档', key: 'band', width: 60 },
        { title: '数量', key: 'count', width: 70 },
        { title: '详情', key: 'detail', minWidth: 220, ellipsis: true }
      ],
      selection: [],
      editVisible: false,
      createMode: false,
      businessCode: '',
      selectedVersionId: null,
      versions: [],
      form: {},
      dimensions: [],
      skipDimSync: false,
      optionMode: 'NONE',
      choiceOptions: [],
      dragTokens: [],
      optionCodes: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
      blanks: [],
      queryParam: {},
      questionTypes: [],
      editQuestionTypes: [],
      editSubSkills: [],
      skipSubSkillSync: false,
      levels: ['L1.0', 'L2.0', 'L3.0', 'L4.0', 'L5.0', 'L6.0', 'L7.0', 'L8.0'],
      tableColumns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: '版本 ID', key: 'currentVersionId', width: 90, ellipsis: true },
        { title: '题头 ID', key: 'id', width: 80, ellipsis: true },
        { title: '业务键', key: 'businessCode', width: 200, ellipsis: true },
        { title: '技能', key: 'skill', width: 140, ellipsis: true, render: (h, p) => h('span', skillLabel(p.row.skill)) },
        { title: '级别', key: 'levelCode', width: 80, ellipsis: true },
        { title: '题型', key: 'questionType', width: 280, ellipsis: true, render: (h, p) => h('span', questionTypeLabel(p.row.questionType, p.row.skill)) },
        { title: '版本', key: 'versionNo', width: 80, ellipsis: true },
        { title: '状态', key: 'status', width: 200, ellipsis: true, render: (h, params) => h('span', this.statusLabel(params.row.status)) },
        { title: '场景', key: 'examScene', width: 220, ellipsis: true, render: (h, params) => h('span', this.examSceneLabel(params.row.examScene)) },
        { title: '锚题', key: 'isAnchor', width: 70, ellipsis: true },
        { title: '曝光', key: 'exposureCount', width: 70, ellipsis: true },
        { title: '通过率', key: 'passRate', width: 80, ellipsis: true },
        { title: '题干', key: 'stem', width: 240, render: (h, p) => this.renderStem(h, p.row.stem) },
        {
          title: '操作',
          key: 'action',
          width: 420,
          render: (h, params) => {
            return h('div', { style: { whiteSpace: 'nowrap' } }, [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.openEdit(params.row) }
              }, '编辑'),
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.changeStatus(params.row, 'online') }
              }, '上线'),
              h('Button', {
                props: { size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.changeStatus(params.row, 'offline') }
              }, '下线'),
              h('Button', {
                props: { size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.markAnchor(params.row) }
              }, params.row.isAnchor === 1 ? '取消锚题' : '标锚题'),
              h('Button', {
                props: { type: 'error', size: 'small' },
                on: { click: () => this.discard(params.row) }
              }, '废弃')
            ])
          }
        }
      ]
    }
  },
  computed: {
    isClozeType () {
      return (this.form.questionType || '') === 'Cloze'
    },
    isFillBlanksType () {
      return (this.form.questionType || '') === 'Fill in the Blanks'
    },
    isWordFormType () {
      let t = this.form.questionType || ''
      return t === 'Fill Passage - Word Form' || t === 'Fill in Blank - Word Form'
    },
    isGapFillType () {
      return (this.form.questionType || '') === 'Gap Fill'
    },
    isPassageMcqType () {
      let t = this.form.questionType || ''
      return t === 'Multiple Choice' || t === 'True/False Judgment' || t === 'Reading Comprehension' ||
        t === 'Advanced Reading' || t === 'Multiple Choice - Reading Comprehension' || t === 'Information Matching'
    },
    isBlankChoiceType () {
      return this.isClozeType || this.isGapFillType || (this.isPassageMcqType && this.blanks.length > 0)
    },
    dimSum () {
      let n = 0
      this.dimensions.forEach(item => {
        n += Number(item.weight) || 0
      })
      return n
    },
    answerPlaceholder () {
      if (this.optionMode === 'CHOICE') return '填选项代号，如 A。多种答案用 | 分隔，如 A|B'
      if (this.optionMode === 'DRAG') return '填拼好后的词或整句，如 ball 或 What do you need?'
      if (this.isClozeType || this.isBlankChoiceType) return '每空填选项代号，多空用 | 连起来，如 A|B|C'
      if (this.isFillBlanksType) return '每空填短语，多空用 | 连起来；答案里有分号也不要拆成多空'
      if (this.isWordFormType) return '每空填变化后的词形，多空用 ; 连起来，如 is coloring; wrote; do'
      if (this.blanks.length) return '可与各空答案一致；多空用 | 连起来，如 hiking|camping'
      return '选择题填 A；判断填 T 或 F；拼写填单词；多种答案用 | 分隔'
    },
    answerHint () {
      if (this.optionMode === 'CHOICE') {
        return '判分只认选项代号，不要填选项文字。例如正确答案是 A，这里就填 A。'
      }
      if (this.optionMode === 'DRAG') {
        return '判分比对拼好后的完整词或整句，和上面拖拽词块顺序无关。'
      }
      if (this.isClozeType || this.isBlankChoiceType) {
        return '每问一个选项代号，多问用 | 分隔。'
      }
      if (this.isFillBlanksType) {
        return '每空填短语，多空用 | 分隔。答案里的分号是短语的一部分，不要按分号拆空。'
      }
      if (this.isWordFormType) {
        return '词库在上面选项里。判分按分号拆空，填变化后的词形，不是词库原词。'
      }
      if (this.blanks.length) {
        return '每空的词已写在上面「填空」里。这里仍建议填一份判分答案，多空用 | 分隔。'
      }
      return '客观题判分比对这一栏。选择题填代号 A；判断填 T 或 F；拼写/填空填单词。多种可接受答案用 | 分隔。'
    },
    editTypeOptions () {
      let skill = this.form && this.form.skill
      let list = []
      let seen = {}
      ;(this.editQuestionTypes || []).forEach(t => {
        if (!t || seen[t]) return
        seen[t] = true
        list.push({ value: t, label: questionTypeLabel(t, skill) })
      })
      let cur = this.form && this.form.questionType
      if (cur && !seen[cur]) {
        list.unshift({ value: cur, label: questionTypeLabel(cur, skill) })
      }
      return list
    },
    subSkillEnOptions () {
      return this.buildSubSkillOptions('en')
    },
    subSkillCnOptions () {
      return this.buildSubSkillOptions('cn')
    }
  },
  watch: {
    optionMode (val) {
      if (((this.form.questionType || '') === 'Cloze' || (this.form.questionType || '') === 'Fill in the Blanks' || this.isBlankChoiceType) && val !== 'NONE') {
        this.optionMode = 'NONE'
        this.choiceOptions = []
        this.dragTokens = []
        return
      }
      if (val === 'CHOICE' && !this.choiceOptions.length) {
        this.choiceOptions = [
          { code: 'A', text: '', image: '' },
          { code: 'B', text: '', image: '' },
          { code: 'C', text: '', image: '' },
          { code: 'D', text: '', image: '' }
        ]
      }
      if (val === 'DRAG' && !this.dragTokens.length) {
        this.dragTokens = [{ value: '' }]
      }
    }
  },
  created () {
    this.loadQuestionTypes()
  },
  methods: {
    questionTypeLabel,
    skillLabel,
    renderStem (h, stem) {
      let text = stem || ''
      if (!text) return h('span', '—')
      return h('Poptip', {
        props: { trigger: 'click', transfer: true, placement: 'bottom', width: 480, wordWrap: true }
      }, [
        h('a', {
          style: {
            display: 'inline-block',
            maxWidth: '220px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            verticalAlign: 'bottom'
          }
        }, text),
        h('div', {
          slot: 'content',
          style: {
            maxHeight: '360px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            lineHeight: '22px'
          }
        }, text)
      ])
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    loadQuestionTypes () {
      this.$http.post('/mex/comp/questions/types', { skill: this.queryParam.skill }).then(res => {
        this.questionTypes = res.status === 'ok' ? (res.data || []) : []
      }).catch(() => {
        this.questionTypes = []
      })
    },
    loadEditQuestionTypes () {
      this.$http.post('/mex/comp/questions/types', { skill: this.form.skill }).then(res => {
        this.editQuestionTypes = res.status === 'ok' ? (res.data || []) : []
      }).catch(() => {
        this.editQuestionTypes = []
      })
    },
    loadEditSubSkills () {
      this.$http.post('/mex/comp/questions/sub-skills', { skill: this.form.skill }).then(res => {
        this.editSubSkills = res.status === 'ok' ? (res.data || []) : []
      }).catch(() => {
        this.editSubSkills = []
      })
    },
    buildSubSkillOptions (field) {
      let list = []
      let seen = {}
      ;(this.editSubSkills || []).forEach(item => {
        let value = field === 'en' ? item.en : item.cn
        if (!value || seen[value]) return
        seen[value] = true
        list.push({ value: value, label: value })
      })
      let cur = field === 'en' ? this.form.subSkillEn : this.form.subSkillCn
      if (cur && !seen[cur]) {
        list.unshift({ value: cur, label: cur })
      }
      return list
    },
    findSubSkillBy (field, value) {
      if (!value) return null
      let rows = this.editSubSkills || []
      for (let i = 0; i < rows.length; i++) {
        if ((field === 'en' ? rows[i].en : rows[i].cn) === value) {
          return rows[i]
        }
      }
      return null
    },
    onSubSkillEnChange (en) {
      if (this.skipSubSkillSync) return
      let pair = this.findSubSkillBy('en', en)
      if (pair && pair.cn && this.form.subSkillCn !== pair.cn) {
        this.skipSubSkillSync = true
        this.form.subSkillCn = pair.cn
        this.$nextTick(() => {
          this.skipSubSkillSync = false
        })
      }
    },
    onSubSkillCnChange (cn) {
      if (this.skipSubSkillSync) return
      let pair = this.findSubSkillBy('cn', cn)
      if (pair && pair.en && this.form.subSkillEn !== pair.en) {
        this.skipSubSkillSync = true
        this.form.subSkillEn = pair.en
        this.$nextTick(() => {
          this.skipSubSkillSync = false
        })
      }
    },
    onEditQuestionTypeChange () {
      this.syncDimensionsToType()
    },
    onFormSkillChange () {
      this.loadEditQuestionTypes()
      this.loadEditSubSkills()
      this.syncDimensionsToType()
    },
    statusLabel (code) {
      if (code === 'PENDING_REVIEW') return '待审核 PENDING_REVIEW'
      if (code === 'ONLINE') return '已上线 ONLINE'
      if (code === 'OFFLINE') return '已下线 OFFLINE'
      if (code === 'DISCARDED') return '已废弃 DISCARDED'
      return code || ''
    },
    examSceneLabel (code) {
      if (code === 'GENERAL') return '通用 GENERAL'
      if (code === 'PLACEMENT_ONLY') return '仅入门测 PLACEMENT_ONLY'
      if (code === 'SUMMATIVE_ONLY') return '仅阶段测 SUMMATIVE_ONLY'
      return code || ''
    },
    dimLabel (key) {
      if (key === 'correctness') return '正确性'
      if (key === 'content') return '内容'
      if (key === 'logic') return '逻辑'
      if (key === 'grammar') return '语法'
      if (key === 'vocab') return '词汇'
      if (key === 'accuracy') return '准确度'
      if (key === 'fluency') return '流利度'
      if (key === 'completeness') return '完整度'
      return key
    },
    isWriteSubjective (skill, questionType) {
      if (skill !== 'Writing') return false
      let t = questionType || ''
      return t.indexOf('Picture Writing') >= 0 || t.indexOf('Practical Writing') >= 0 || t.indexOf('Guided Writing') >= 0
    },
    defaultDimensions (skill, questionType) {
      if (this.isWriteSubjective(skill, questionType)) {
        return [
          { key: 'content', weight: 30 },
          { key: 'logic', weight: 20 },
          { key: 'grammar', weight: 30 },
          { key: 'vocab', weight: 20 }
        ]
      }
      return [
        { key: 'correctness', weight: 100 }
      ]
    },
    toPercent (val) {
      let n = Number(val)
      if (isNaN(n)) return 0
      if (n > 1) return n
      return Math.round(n * 1000) / 10
    },
    parseDimensions (raw, skill, questionType) {
      let defaults = this.defaultDimensions(skill, questionType)
      if (!raw) return defaults
      try {
        let obj = typeof raw === 'string' ? JSON.parse(raw) : raw
        if (!obj || typeof obj !== 'object' || obj.length != null) {
          this.$Message.warning('原评分维度无法解析，已套用默认值')
          return defaults
        }
        let used = {}
        let list = defaults.map(item => {
          used[item.key] = true
          let val = obj[item.key]
          return {
            key: item.key,
            weight: val == null ? item.weight : this.toPercent(val)
          }
        })
        Object.keys(obj).forEach(key => {
          if (!used[key]) {
            list.push({ key: key, weight: this.toPercent(obj[key]) })
          }
        })
        return list
      } catch (e) {
        this.$Message.warning('原评分维度无法解析，已套用默认值')
        return defaults
      }
    },
    stringifyDimensions () {
      let obj = {}
      this.dimensions.forEach(item => {
        if (item.key) {
          obj[item.key] = Math.round((Number(item.weight) || 0) * 10) / 1000
        }
      })
      return JSON.stringify(obj)
    },
    nextChoiceCode () {
      let used = {}
      this.choiceOptions.forEach(item => {
        used[item.code] = true
      })
      for (let i = 0; i < this.optionCodes.length; i++) {
        if (!used[this.optionCodes[i]]) return this.optionCodes[i]
      }
      return this.optionCodes[this.choiceOptions.length % this.optionCodes.length]
    },
    emptyChoice () {
      return { code: this.nextChoiceCode(), text: '', image: '' }
    },
    resetOptions () {
      this.optionMode = 'NONE'
      this.choiceOptions = []
      this.dragTokens = []
    },
    parseOptions (raw) {
      this.resetOptions()
      if (!raw) return
      try {
        let data = typeof raw === 'string' ? JSON.parse(raw) : raw
        if (Array.isArray(data)) {
          if (!data.length) return
          if ((this.form.questionType || '') === 'Cloze' || (this.form.questionType || '') === 'Gap Fill' || (this.form.questionType || '') === 'Fill in the Blanks' || this.isBlankChoiceType) {
            this.optionMode = 'NONE'
            this.choiceOptions = []
            return
          }
          if ((this.form.questionType || '') === 'Picture Writing - Four Panel Story') {
            this.optionMode = 'NONE'
            this.choiceOptions = []
            return
          }
          let dragTokens = this.tokensFromMisimportedChoice(data)
          if (dragTokens) {
            this.optionMode = 'DRAG'
            this.dragTokens = dragTokens
            return
          }
          this.optionMode = 'CHOICE'
          this.choiceOptions = data.map((item, i) => {
            if (typeof item === 'string') {
              return { code: this.optionCodes[i] || String(i + 1), text: item, image: '' }
            }
            return {
              code: item.code || this.optionCodes[i] || '',
              text: item.text || '',
              image: item.image || ''
            }
          })
          return
        }
        if (data && (data.mode === 'DRAG' || data.tokens)) {
          this.optionMode = 'DRAG'
          let tokens = data.tokens || []
          this.dragTokens = tokens.map(t => {
            return { value: t == null ? '' : String(t) }
          })
          if (!this.dragTokens.length) {
            this.dragTokens = [{ value: '' }]
          }
          return
        }
        this.$Message.warning('原选项无法按选择题或拖拽解析，已清空')
      } catch (e) {
        this.$Message.warning('原选项无法解析，已清空')
      }
    },
    isDragTokenType (type) {
      let t = type || ''
      return t.indexOf('Drag Letters') === 0 || t === 'Sequence - Sentence Ordering'
    },
    tokensFromMisimportedChoice (data) {
      if (!this.isDragTokenType(this.form.questionType) || !data || data.length !== 1) return null
      let text = (typeof data[0] === 'string' ? data[0] : (data[0].text || '')).replace(/｜/g, '|')
      if (text.indexOf('|') < 0) return null
      let tokens = text.split('|').map(s => s.trim()).filter(s => s).map(v => {
        return { value: v }
      })
      return tokens.length ? tokens : null
    },
    stringifyOptions () {
      if (this.optionMode === 'DRAG') {
        let tokens = this.dragTokens.map(item => (item.value || '').trim()).filter(v => v)
        if (!tokens.length) return '[]'
        return JSON.stringify({ mode: 'DRAG', tokens: tokens })
      }
      if (this.optionMode !== 'CHOICE') return '[]'
      let list = this.choiceOptions.filter(item => item.code && (item.text || (!this.isWordFormType && item.image))).map(item => {
        if (this.isWordFormType) {
          return {
            code: item.code,
            text: item.text || ''
          }
        }
        return {
          code: item.code,
          text: item.text || '',
          image: item.image || ''
        }
      })
      return JSON.stringify(list)
    },
    addChoice () {
      this.choiceOptions.push(this.emptyChoice())
    },
    removeChoice (idx) {
      this.choiceOptions.splice(idx, 1)
    },
    addDrag () {
      this.dragTokens.push({ value: '' })
    },
    removeDrag (idx) {
      if (this.dragTokens.length <= 1) {
        this.dragTokens = [{ value: '' }]
        return
      }
      this.dragTokens.splice(idx, 1)
    },
    nextBlankNo () {
      let max = 0
      this.blanks.forEach(item => {
        let n = Number(item.no) || 0
        if (n > max) max = n
      })
      return max + 1
    },
    parseBlanks (raw) {
      this.blanks = []
      if (!raw) return
      try {
        let data = typeof raw === 'string' ? JSON.parse(raw) : raw
        if (!data || !data.length) return
        this.blanks = data.map((item, i) => {
          if (typeof item === 'string') {
            return { no: i + 1, prompt: '', answer: item, explanation: '' }
          }
          return {
            no: item.no == null ? i + 1 : Number(item.no),
            prompt: item.prompt || '',
            answer: item.answer || '',
            explanation: item.explanation || '',
            options: this.normalizeBlankOptions(item.options)
          }
        })
      } catch (e) {
        this.$Message.warning('原填空无法解析，已清空')
        this.blanks = []
      }
    },
    stringifyBlanks () {
      let list = this.blanks.filter(item => item.prompt || item.answer || item.explanation || (item.options && item.options.length)).map(item => {
        let row = {
          no: Number(item.no) || 0,
          prompt: item.prompt || '',
          answer: item.answer || '',
          explanation: item.explanation || ''
        }
        if (this.isClozeType || this.isBlankChoiceType) {
          row.options = this.normalizeBlankOptions(item.options)
        }
        return row
      })
      return JSON.stringify(list)
    },
    addBlank () {
      this.blanks.push(this.emptyBlank())
    },
    emptyBlank () {
      let row = { no: this.nextBlankNo(), prompt: '', answer: '', explanation: '' }
      if (this.isClozeType || this.isBlankChoiceType) {
        row.options = this.defaultBlankOptions()
      }
      return row
    },
    defaultBlankOptions () {
      if (this.isGapFillType) {
        return ['A', 'B', 'C', 'D', 'E', 'F', 'G'].map(c => {
          return { code: c, text: '', image: '' }
        })
      }
      return [
        { code: 'A', text: '', image: '' },
        { code: 'B', text: '', image: '' },
        { code: 'C', text: '', image: '' },
        { code: 'D', text: '', image: '' }
      ]
    },
    normalizeBlankOptions (raw) {
      if (!raw || !raw.length) {
        return (this.isClozeType || this.isBlankChoiceType) ? this.defaultBlankOptions() : []
      }
      return raw.map((item, i) => {
        if (typeof item === 'string') {
          return { code: this.optionCodes[i] || String(i + 1), text: item, image: '' }
        }
        return {
          code: item.code || this.optionCodes[i] || '',
          text: item.text || '',
          image: item.image || ''
        }
      })
    },
    hydrateClozeBlanks () {
      let t = this.form.questionType || ''
      if (t === 'Cloze' || t === 'Gap Fill' || t === 'Fill in the Blanks' || (this.isPassageMcqType && this.blanks.length)) {
        this.optionMode = 'NONE'
        this.choiceOptions = []
      }
      if (t === 'Picture Writing - Four Panel Story') {
        this.optionMode = 'NONE'
        this.choiceOptions = []
      }
      if (t === 'Cloze' || t === 'Gap Fill' || (this.isPassageMcqType && this.blanks.length)) {
        this.blanks.forEach(item => {
          item.options = this.normalizeBlankOptions(item.options)
        })
      }
    },
    splitClozeExplanation (raw) {
      if (!raw) return []
      let text = String(raw).trim()
      let chunks = []
      if (/^(?:空\s*)?\d+[.)．、:：\s]/m.test(text)) {
        chunks = text.split(/(?=^(?:空\s*)?\d+[.)．、:：\s])/m)
      } else if (text.indexOf(';') >= 0 || text.indexOf('；') >= 0) {
        chunks = text.split(/[;；]/)
      } else {
        chunks = [text]
      }
      return chunks.map(s => s.replace(/^(?:空\s*)?(?:[A-Da-d]|\d+)[.)．、:：\-\s]+/, '').trim()).filter(s => s)
    },
    joinClozeExplanation () {
      return this.blanks.filter(item => item.explanation).map((item, i) => {
        return (item.no || i + 1) + '. ' + item.explanation
      }).join('\n')
    },
    removeBlank (idx) {
      this.blanks.splice(idx, 1)
    },
    syncDimensionsToType () {
      if (this.skipDimSync) return
      let prev = {}
      this.dimensions.forEach(item => {
        prev[item.key] = item.weight
      })
      this.dimensions = this.defaultDimensions(this.form.skill, this.form.questionType).map(item => {
        return {
          key: item.key,
          weight: prev[item.key] == null ? item.weight : prev[item.key]
        }
      })
    },
    search () {
      this.selection = []
      this.reload = Date.now()
      this.$nextTick(() => {
        if (this.$refs.list) {
          this.$refs.list.search()
        }
      })
    },
    selectionChange (selection) {
      this.selection = selection || []
    },
    openBatch () {
      this.batchVisible = true
    },
    openBankInspect () {
      this.inspectLoading = true
      this.inspectVisible = true
      this.$http.get('/mex/placement/bank/inspect').then(res => {
        this.inspectLoading = false
        if (res.status === 'ok') {
          this.inspectReport = res.data || {}
          let issues = (this.inspectReport.issues) || []
          this.inspectRows = issues.map(row => ({
            code: row.code || '',
            bank: row.bank || '',
            id: row.id == null ? '' : row.id,
            level: row.level || '',
            skill: row.skill || '',
            band: row.band || '',
            count: row.count == null ? '' : row.count,
            detail: row.detail || ''
          }))
        } else {
          this.$Message.error(res.msg || '自检失败')
        }
      }).catch(() => {
        this.inspectLoading = false
        this.$Message.error('自检失败')
      })
    },
    escapeHtml (s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    },
    showImportResult (d, prefix) {
      let data = d || {}
      let msg = (prefix || '导入') + '成功 ' + (data.successCount || 0) + '，跳过 ' + (data.skipCount || 0) + '，失败 ' + (data.failCount || 0)
      let rows = data.failRows || []
      if (rows.length) {
        let body = rows.map(r => this.escapeHtml(r)).join('<br>')
        this.$Modal.warning({
          title: '导入结果',
          width: 720,
          content: this.escapeHtml(msg) + '<br><pre style="max-height:320px;overflow:auto;white-space:pre-wrap">' + body + '</pre>'
        })
      } else {
        this.$Message.success(msg)
      }
    },
    triggerImport (skill) {
      this.importSkill = skill
      this.$refs.fileInput.click()
    },
    downloadTemplate () {
      this.$http.get('/mex/comp/questions/template', { responseType: 'arraybuffer' }).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = '综合题库导入模板.xlsx'
        link.click()
      }).catch(() => {
        this.$Message.error('模板下载失败')
      })
    },
    importData (event) {
      let file = event.target.files[0]
      if (!file) return
      let formData = new FormData()
      formData.append('file', file)
      formData.append('skill', this.importSkill)
      this.$http.post('/mex/comp/questions/import', formData, { transformRequest: [] }).then(res => {
        if (res.status === 'ok') {
          this.showImportResult(res.data, this.importSkill)
          this.loadQuestionTypes()
          this.search()
        } else {
          this.$Message.error(res.msg || '导入失败')
        }
        this.$refs.fileInput.value = ''
      }).catch(() => {
        this.$Message.error('导入失败')
        this.$refs.fileInput.value = ''
      })
    },
    triggerIrt () {
      this.$refs.irtInput.click()
    },
    importIrt (event) {
      let file = event.target.files[0]
      if (!file) return
      let formData = new FormData()
      formData.append('file', file)
      this.$http.post('/mex/comp/questions/irt', formData, { transformRequest: [] }).then(res => {
        if (res.status === 'ok') {
          this.showImportResult(res.data, 'IRT')
          this.search()
        } else {
          this.$Message.error(res.msg || 'IRT 回填失败')
        }
        this.$refs.irtInput.value = ''
      }).catch(() => {
        this.$Message.error('IRT 回填失败')
        this.$refs.irtInput.value = ''
      })
    },
    openCreate () {
      this.createMode = true
      this.businessCode = ''
      this.versions = []
      this.selectedVersionId = null
      this.skipDimSync = true
      this.form = {
        skill: 'Listening',
        levelCode: 'L1.0',
        examScene: 'GENERAL',
        questionType: '',
        stem: '',
        versionNo: 'v1.0',
        status: 'PENDING_REVIEW'
      }
      this.dimensions = this.defaultDimensions(this.form.skill, this.form.questionType)
      this.resetOptions()
      this.blanks = []
      this.editVisible = true
      this.loadEditQuestionTypes()
      this.loadEditSubSkills()
      this.$nextTick(() => {
        this.skipDimSync = false
      })
    },
    applyDetail (data) {
      this.skipDimSync = true
      this.businessCode = data.businessCode
      this.form = data.comp || {}
      this.dimensions = this.parseDimensions(this.form.dimensionsJson, this.form.skill, this.form.questionType)
      this.parseBlanks(this.form.blanksJson)
      this.parseOptions(this.form.optionsJson)
      this.hydrateClozeBlanks()
      this.versions = data.versions || []
      this.selectedVersionId = this.form.id
      this.createMode = false
      this.editVisible = true
      this.loadEditQuestionTypes()
      this.loadEditSubSkills()
      this.$nextTick(() => {
        this.skipDimSync = false
      })
    },
    openEdit (row) {
      this.$http.post('/mex/comp/questions/detail', { versionId: row.currentVersionId }).then(res => {
        if (res.status === 'ok' && res.data && res.data.comp) {
          this.applyDetail(res.data)
        } else {
          this.$Message.error(res.msg || '加载失败')
        }
      })
    },
    switchVersion (versionId) {
      if (!versionId || versionId === this.form.id) return
      this.$http.post('/mex/comp/questions/detail', { versionId: versionId }).then(res => {
        if (res.status === 'ok' && res.data && res.data.comp) {
          this.applyDetail(res.data)
        } else {
          this.$Message.error(res.msg || '加载失败')
        }
      })
    },
    savePayload () {
      let payload = Object.assign({}, this.form)
      delete payload.gmtCreate
      delete payload.gmtModified
      delete payload.reviewedAt
      delete payload.reviewer
      delete payload.checksum
      return payload
    },
    saveEdit () {
      this.form.dimensionsJson = this.stringifyDimensions()
      this.form.optionsJson = this.stringifyOptions()
      this.form.blanksJson = this.stringifyBlanks()
      if (this.isClozeType || this.isFillBlanksType || this.isBlankChoiceType) {
        this.form.optionsJson = '[]'
        this.form.explanation = this.joinClozeExplanation()
        if (this.blanks.length) {
          this.form.answerKey = this.blanks.filter(item => item.answer).map(item => item.answer).join('|')
        }
      } else if (this.isWordFormType) {
        this.form.explanation = this.joinClozeExplanation()
        if (this.blanks.length) {
          this.form.answerKey = this.blanks.filter(item => item.answer).map(item => item.answer).join(';')
        }
      }
      if (this.createMode) {
        let payload = Object.assign({}, this.savePayload(), { businessCode: this.businessCode })
        this.$http.post('/mex/comp/questions/create', payload).then(res => {
          if (res.status === 'ok') {
            this.$Message.success('已新建，待审核上线')
            this.editVisible = false
            this.loadQuestionTypes()
            this.search()
          } else {
            this.$Message.error(res.msg || '保存失败')
          }
        })
        return
      }
      this.$http.post('/mex/comp/questions/save', this.savePayload()).then(res => {
        if (res.status === 'ok') {
          this.$Message.success(this.form.status === 'ONLINE' ? '已升版本，待审核上线' : '已保存')
          this.editVisible = false
          this.loadQuestionTypes()
          this.search()
        } else {
          this.$Message.error(res.msg || '保存失败')
        }
      })
    },
    changeStatus (row, action) {
      if (action === 'online') {
        this.$Modal.confirm({
          title: '确认上线',
          content: '上线该版本后，同一题目其它已上线版本会自动下线。',
          onOk: () => this.doChangeStatus(row, action)
        })
        return
      }
      this.doChangeStatus(row, action)
    },
    doChangeStatus (row, action) {
      this.$http.post('/mex/comp/questions/' + action, { versionId: row.currentVersionId }).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('已更新')
          this.search()
        } else {
          this.$Message.error(res.msg || '操作失败')
        }
      })
    },
    discard (row) {
      this.$Modal.confirm({
        title: '废弃版本',
        content: '确认废弃该版本？已上线须先下线。不能回滚，只能再上线其它版本。',
        onOk: () => {
          this.$http.post('/mex/comp/questions/discard', { versionId: row.currentVersionId }).then(res => {
            if (res.status === 'ok') {
              this.$Message.success('已废弃')
              this.search()
            } else {
              this.$Message.error(res.msg || '操作失败')
            }
          })
        }
      })
    },
    markAnchor (row) {
      this.$http.post('/mex/comp/questions/anchor', {
        versionId: row.currentVersionId,
        isAnchor: row.isAnchor === 1 ? 0 : 1
      }).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('已更新锚题')
          this.search()
        } else {
          this.$Message.error(res.msg || '操作失败')
        }
      })
    }
  }
}
</script>

<style lang="less">
@import './mex-search.less';

.mex-dim-hint {
  margin: 0 0 8px;
  color: #808695;
  line-height: 20px;
}

.mex-dim-card {
  background: #f8f8f9;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  padding: 8px 12px 0;

  .ivu-form-item {
    margin-bottom: 10px;
  }

  .ivu-form-item-label {
    padding: 0 0 4px;
    line-height: 18px;
    float: none;
  }

  .ivu-form-item-content {
    margin-left: 0 !important;
  }

  .ivu-input-number,
  .ivu-select {
    width: 100%;
  }
}

.mex-opt-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// MexCompQuestionList.vue?aedd6fb8